import { IonBackButton, IonButtons, IonHeader, IonTitle, IonToolbar } from '@ionic/react';

import { getImplicitPlatform } from '../App';
import { WebHeader } from './web/WebHeader';

export const Header: React.FC<{ title?: string; backText?: string; backLocation?: string }> = ({
    title,
    backText,
    backLocation,
}) => {
    if (getImplicitPlatform() == 'ios') {
        return (
            <IonHeader collapse="condense">
                <IonToolbar>
                    <>
                        {title && (
                            <IonTitle className="text-2xl font-bold" size="large">
                                {title}
                            </IonTitle>
                        )}
                    </>
                </IonToolbar>
            </IonHeader>
        );
    }

    if (getImplicitPlatform() == 'web') {
        return <WebHeader title={title || ''} />;
    }

    if (getImplicitPlatform() == 'android') {
        return (
            <IonHeader>
                {backText && (
                    <IonButtons>
                        <IonBackButton defaultHref={backLocation || '/'} text={backText || 'Retour'} />
                    </IonButtons>
                )}
                {title && (
                    <IonTitle size="large" className="text-2xl font-bold pt-10">
                        {title}
                    </IonTitle>
                )}
            </IonHeader>
        );
    }

    return null;
};
